import {
  type TitleProject,
  type TitleProjectInput,
  titleProjectSchema,
} from '@noconflict/contracts';
import type { Supabase } from '../../shared/api/supabase';

/** The intake details of a title project (RLS: whoever may read the project), or null when it has none. */
export async function getTitleProject(
  client: Supabase,
  projectId: string,
): Promise<TitleProject | null> {
  const { data, error } = await client
    .from('title_projects')
    .select('*')
    .eq('project_id', projectId)
    .maybeSingle();
  if (error) throw new Error(error.message);
  return data ? titleProjectSchema.parse(data) : null;
}

/**
 * Saves the details while the project is a draft; the project's name follows the title. Needs `projects.edit`,
 * and is refused with `project_not_draft` once the order has been submitted.
 */
export async function updateTitleProject(
  client: Supabase,
  projectId: string,
  input: TitleProjectInput,
): Promise<void> {
  const { error } = await client.rpc('update_title_project', {
    p_project_id: projectId,
    p_title: input.title as string,
    p_production_type: input.productionType as string,
    p_production_company: input.productionCompany as string,
    p_notes: input.notes as string,
  });
  if (error) throw new Error(error.message);
}
